export const TAB_INDEX = "TAB_INDEX";
export const TAB_NAME = "TAB_NAME";
export const FILTER_NETWORK = "FILTER_NETWORK";
export const FILTER_DC = "FILTER_DC";
export const FILTER_PRODUCTS = "FILTER_PRODUCTS";
export const FILTER_CUSTOMERS = "FILTER_CUSTOMERS";
export const FILTER_PL3 = "FILTER_PL3";
export const FILTER_CL6 = "FILTER_CL6";
export const FILTER_DIVISION = "FILTER_DIVISION";
export const FILTER_SAVEDNAMES = "FILTER_SAVEDNAMES";
export const FILTER_NAMES = "FILTER_NAMES";
export const FILTER_DATERANGE = "FILTER_DATERANGE";
export const APPLY_FILTER = "APPLY_FILTER";
export const SAVE_FILTER = "SAVE_FILTER";
export const DELETE_FILTER = "DELETE_FILTER";
export const SET_FILTER = "SET_FILTER";
export const SET_LOGIN = "SET_LOGIN";
export const SET_ROLE = "SET_ROLE";
export const FILTER_PERIOD_TYPE = "FILTER_PERIOD_TYPE";
export const SET_VIEW_POWER_BI = "SET_VIEW_POWER_BI";
export const SET_VIEW_POWER_BI_ALERTS = "SET_VIEW_POWER_BI_ALERTS";
export const SET_VIEW_POWER_BI_DATA = "SET_VIEW_POWER_BI_DATA";
export const SET_DEEPDRIVE_TAB = "SET_DEEPDRIVE_TAB";
export const SET_ACTIVE_ROUTE = "SET_ACTIVE_ROUTE";
export const SET_FILTER_PL3 = "SET_FILTER_PL3";
export const SET_FILTER_DIVISION = "SET_FILTER_DIVISION";
export const SET_FILTER_LIST = "SET_FILTER_LIST";
export const SET_FILTER_PRODUCTS = "SET_FILTER_PRODUCTS";
export const SET_FILTER_CUSTOMER = "SET_FILTER_CUSTOMER";
export const SET_ACCESS_DETAILS = "SET_ACCESS_DETAILS";
export const SET_PAST_DUE_CHECK = "SET_PAST_DUE_CHECK";
export const SET_ACTIVE_FLAG = "SET_ACTIVE_FLAG";
export const SET_SCENARIOS = "SET_SCENARIOS";
export const SET_ACTIVE_SCENARIOS = "SET_ACTIVE_SCENARIOS";
export const SET_ACTIVE_EVENTS_COUNT = "SET_ACTIVE_EVENTS_COUNT";
export const SET_SELECTED_SCENARIOS = "SET_SELECTED_SCENARIOS";
export const SET_RECOM_FLAG = "SET_RECOM_FLAG";
export const SET_GRAPH_OR_MAP_VIEW = "SET_GRAPH_OR_MAP_VIEW";
export const FROM_STATE = "FROM_STATE";
export const TO_STATE = "TO_STATE";
export const FROM_ZIP = "FROM_ZIP";
export const TO_ZIP = "TO_ZIP";
export const LANE = "LANE";
export const TEMPERATURE = "TEMPERATURE";
export const FAC_ID = "FAC_ID";
export const LOCATION = "LOCATION";
export const FAC_TYPE = "FAC_TYPE";
export const SET_SCENARIO_FLAG = "SET_SCENARIO_FLAG";
export const RAPID_RESPONSE_FILTER_DATERANGE =
  "RAPID_RESPONSE_FILTER_DATERANGE";
export const CP_DATERANGE = "CP_DATERANGE";
export const DIP_DATERANGE = "DIP_DATERANGE";
export const SHOW_ALERT_GRAPH = "SHOW_ALERT_GRAPH";
export const MODULE_TAB_INDEX = "MODULE_TAB_INDEX";
export const SET_UNIT_VALUE = "SET_UNIT_VALUE";
export const SET_SELECTED_NETWORKS = "SET_SELECTED_NETWORKS";
export const SET_DETAILS_SWITCH = "SET_DETAILS_SWITCH";
export const SET_DETENTION_DATERANGE = "SET_DETENTION_DATERANGE";
export const SET_INCLUDE_NPOOS = "SET_INCLUDE_NPOOS";
export const SET_POOS_RADIO_BUTTON = "SET_POOS_RADIO_BUTTON";
export const SET_IOFPB_RADIO_BUTTON = "SET_IOFPB_RADIO_BUTTON";
export const SET_INCOTERM = "SET_INCOTERM";
export const FGS_DATERANGE = "FGS_DATERANGE";
